import React, { useState } from "react";
import { Modal } from "../../components/Modal";
import {
    Box,
    Button,
    Checkbox,
    FormControl,
    FormControlLabel,
    FormHelperText,
    FormLabel,
    Grid,
    ListItemText,
    MenuItem,
    OutlinedInput,
    Select,
    TextField,
    Typography,
    Link as MUILink
} from "@mui/material";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { create } from "../../services/salesforce";
import { InfoOutlined } from "@mui/icons-material";
import { Link } from "react-router-dom";

const validateForm = (
    values,
    disabledValidationFields = {
        dateFields: false,
        addressFields: false,
        additionalDetails: true,
    }
) => {
    const errors = {};

    // Fee Type Validation (Array)
    if (!values.feeType || values.feeType.length === 0) {
        errors.feeType = "At least one fee type must be selected";
    }

    if (!disabledValidationFields.additionalDetails && !values.additionalDetails) {
        errors.additionalDetails = "Additional Details is required";
    }

    if (!disabledValidationFields?.dateFields) {
        if (!values.startEventDate) {
            errors.startEventDate = "Start Event Date is required";
        }
        if (!values.endEventDate) {
            errors.endEventDate = "End Event Date is required";
        }
    }

    if (!disabledValidationFields?.addressFields && values.eventType === "In person") {
        if (!values.eventCity) {
            errors.eventCity = "Event City is required";
        }
    }

    if (!values.eventState && values.eventType === "In person") {
        errors.eventState = "Event State is required";
    }

    if (!values.eventCountry) {
        errors.eventCountry = "Event Country is required";
    }

    if (!values.requestNotes) {
        errors.requestNotes = "Request Details is required";
    }

    return errors;
};
function RequestFeeFormModal({
    openRequestFeeModal = false,
    requestFeeModalCloseHandler,
    userDetails = {},
    ProfilePicUI = null,
    record,
    getSpeakerLocation,
    countryPicklist = [],
}) {
    const [requestFeeData, setRequestFeeData] = useState({
        clientName: "",
        feeType: [],
        additionalDetails: "",
        startEventDate: "",
        endEventDate: "",
        eventCity: "",
        eventState: "",
        eventCountry: "",
        requestNotes: "",
        eventType: "In person",
    });
    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});

    const [isEventDatesTBHChecked, setIsEventDatesTBHChecked] = useState(false);
    const [isAddressTBHChecked, setIsAddressTBHChecked] = useState(false);

    const getSpeakerFeesList = (fees) => {
        if (fees?.length > 0) {
            let allFee = fees.sort((a, b) => {
                // Check if 'Name' contains 'Contact US'
                let aHasContactUS =
                    a.name?.toLowerCase().includes(" us ") ||
                    a.name?.toLowerCase().includes(" us") ||
                    a.name?.toLowerCase().includes("us ") ||
                    a.name?.toLowerCase().startsWith("us");
                let bHasContactUS =
                    b.name?.toLowerCase().includes(" us ") ||
                    b.name?.toLowerCase().includes(" us") ||
                    b.name?.toLowerCase().includes("us ") ||
                    b.name?.toLowerCase().startsWith("us");
                let aHasVirtual = a.name?.toLowerCase().includes("virtual");
                let bHasVirtual = b.name?.toLowerCase().includes("virtual");

                // If 'a' contains 'Contact US' and 'b' does not, 'a' should come first
                if (aHasContactUS && !bHasContactUS) return -1;
                // If 'b' contains 'Contact US' and 'a' does not, 'b' should come first
                if (!aHasContactUS && bHasContactUS) return 1;

                if (aHasVirtual && !bHasContactUS && !bHasVirtual) return -1;
                if (bHasVirtual && !aHasContactUS && !aHasVirtual) return 1;

                // If both or neither contain 'Contact US', sort alphabetically (case-insensitive)
                return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
            });

            let newList = allFee;

            return newList.map((item) => item.name) || [];
        }
        return [];
    };

    let feeRanges = getSpeakerFeesList(record?.regionFeeRanges) || [];

    const options =
        feeRanges?.length > 0
            ? [...getSpeakerFeesList(record?.regionFeeRanges), "Custom"]
            : ["East", "West", "Virtual", "Custom"];

    const validateFormWithConditions = (values) => {
        return validateForm(values, {
            dateFields: isEventDatesTBHChecked,
            addressFields: isAddressTBHChecked,
            additionalDetails: requestFeeData?.feeType?.includes("Custom") ? false : true,
        });
    };

    const requestFeeDataHandler = (value, name) => {
        let data = {};
        data[name] = value;
        if (name === "eventType" && value === "Virtual") {
            data["eventCity"] = "";
            data["eventState"] = "";
            data["cityTBD"] = false;
            data["eventCountry"] = "Virtual / Remote Broadcast"; //add eventCountry if value Virtual
        }

        // if (name === "startEventDate" && value && !requestFeeData.endEventDate) {
        //     data["endEventDate"] = value;
        // }
        if (name === "startEventDate" && value) {
            data["endEventDate"] = value;
        }
        setRequestFeeData((prevState) => ({
            ...prevState,
            ...data,
        }));

        if (touched[name]) {
            setErrors(validateFormWithConditions({ ...requestFeeData, [name]: value }));
        }
    };

    const handleBlur = (e) => {
        setTouched({ ...touched, [e.target.name]: true });
        setErrors(validateFormWithConditions(requestFeeData));
    };

    const handleRequestFeeSubmit = () => {
        const allTouched = Object.keys(requestFeeData).reduce((prevState, currentKey) => {
            return {
                ...prevState,
                [currentKey]: true,
            };
        }, {});
        const validationErrors = validateFormWithConditions(requestFeeData);
        setErrors(validationErrors);
        setTouched(allTouched);
        scrollToErrorMessage();

        if (Object.keys(validationErrors).length === 0) {
            requestFeeModalCloseHandler();

            // adding accountId,name,requestById,speakerId,status in request fee data

            // for now adding start event date
            // const requestFeeDataTimestamp = requestFeeData?.eventDate ? new Date(requestFeeData?.eventDate).getTime() + requestFeeData?.eventDate.utcOffset() * 60 * 1000 : 0;

            if (requestFeeData?.startEventDate) {
                const requestFeeStartDateTimestamp = requestFeeData?.startEventDate
                    ? new Date(requestFeeData?.startEventDate).getTime() +
                      requestFeeData?.startEventDate.utcOffset() * 60 * 1000
                    : 0;
                requestFeeData.startDate = new Date(requestFeeStartDateTimestamp);
            }

            if (requestFeeData?.endEventDate) {
                const requestFeeEndDateTimestamp = requestFeeData?.endEventDate
                    ? new Date(requestFeeData?.endEventDate).getTime() +
                      requestFeeData?.endEventDate.utcOffset() * 60 * 1000
                    : 0;

                requestFeeData.endDate = new Date(requestFeeEndDateTimestamp);
            }

            requestFeeData.accountId = userDetails.contact?.accountId;
            requestFeeData.speakerId = record.Id;
            requestFeeData.requestById = userDetails.contact.id;
            requestFeeData.status = "New";
            // requestFeeData.name = `${record.name} - ${requestFeeData.eventName}`;// event name field is removed
            requestFeeData.name = `${record.name} - ${requestFeeData.clientName}`;
            requestFeeData.eventDateTBD = isEventDatesTBHChecked;
            requestFeeData.cityTBD = isAddressTBHChecked;
            if (requestFeeData.additionalDetails) {
                requestFeeData.feeTypeAdditionalDetail = requestFeeData.additionalDetails;
            }

            if (!requestFeeData?.feeType?.includes("Custom")) {
                requestFeeData.additionalDetails = "";
            }

            // console.log("requestFeeData submitted... ", requestFeeData);
            // return

            create("feeRequest", requestFeeData).then((result) => {
                if (result.isSuccess) {
                    const detailEvent = new CustomEvent("openToster", {
                        detail: {
                            variant: "success",
                            message: <>Your fee request has been submitted. Visit <MUILink component={Link} sx={{
                                textDecoration:'underline'
                            }} to={'/my-fee-requests'} >My Speaker Requests</MUILink> to view.</>,
                        },
                    });
                    document.dispatchEvent(detailEvent);
                }
            });
        }
    };

    const scrollToErrorMessage = () => {
        // scroll to first error message
        setTimeout(() => {
            const allInputs = document.querySelectorAll("#request-fee-form .MuiOutlinedInput-root.Mui-error");
            if (allInputs.length > 0) {
                const lastInput = allInputs[0];
                lastInput.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }, 100);
    };

    const handleAddressCityTBH = (e) => {
        setIsAddressTBHChecked(e.target.checked);
        setRequestFeeData((prevState) => ({
            ...prevState,
            eventCity: "",
        }));
    };
    const handleEventDateTBH = (e) => {
        setIsEventDatesTBHChecked(e.target.checked);
        setRequestFeeData((prevState) => ({
            ...prevState,
            startEventDate: "",
            endEventDate: "",
        }));
    };

    const AstricUI = <span style={{ marginLeft: "-2px" }}>*</span>;

    return (
        <>
            <Modal
                open={openRequestFeeModal}
                title="Request Fee"
                sx={{ padding: "0px" }}
                contentSx={
                    {
                        // overflowY: "hidden"
                    }
                }
                onClose={requestFeeModalCloseHandler}
                actions={
                    <>
                        <Button variant="outlined" onClick={requestFeeModalCloseHandler}>
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            sx={{
                                background: "#444CE7",
                                borderColor: "#2D31A6",
                            }}
                            onClick={handleRequestFeeSubmit}>
                            Submit
                        </Button>
                    </>
                }>
                <Box
                    sx={{
                        borderRadius: "10px",
                        border: "1px solid #EEF4FF",
                        background: "#F5F8FF",
                        padding: "16px",

                        display: "flex",
                    }}>
                    {ProfilePicUI}

                    <Box
                        marginLeft={"1rem"}
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                        }}>
                        <Typography fontSize={"1.1rem"} fontWeight={600} color={"#101828"} lineHeight={"1.5rem"}>
                            {record.name}
                        </Typography>
                        {getSpeakerLocation(record) && (
                            <Typography
                                fontSize={"0.875rem"}
                                fontWeight={400}
                                color={"#475467"}
                                lineHeight={"1.1rem"}
                                display={"flex"}
                                marginTop={"0.25rem"}
                                alignItems={"center"}>
                                <LocationOnOutlinedIcon
                                    color="brand"
                                    fontSize="small"
                                    sx={{ marginRight: "0.25rem" }}
                                />
                                {getSpeakerLocation(record) || ""}
                            </Typography>
                        )}
                    </Box>
                </Box>

                <Box
                    id="request-fee-form"
                    sx={(theme) => ({
                        "& .MuiFormControl-root": {
                            marginTop: "1rem",

                            "& .MuiFormLabel-root": {
                                fontSize: "14px",
                                fontWeight: 500,

                                "&.MuiFormLabel-colorPrimary": {
                                    color: theme.palette.gray.main,
                                },
                                "&.Mui-error": {
                                    color: theme.palette.error.main,
                                },
                                "&.Mui-disabled": {
                                    color: "rgba(55, 65, 81, 0.48)",
                                },
                            },

                            "&.disabledGuttorTop": {
                                marginTop: 0,
                            },

                            "& .MuiInputBase-root.MuiOutlinedInput-root": {
                                width: "100%",
                                marginTop: "0.5rem",
                                padding: 0,

                                "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                    padding: "10px 16px",
                                },
                            },
                        },
                    })}>
                    <FormControl sx={{ width: "100%" }}>
                        <FormLabel error={Boolean(touched.clientName && errors.clientName)}>
                            Client / Bureau Name
                        </FormLabel>
                        <OutlinedInput
                            placeholder="Enter client / bureau name"
                            sx={{}}
                            name="clientName"
                            value={requestFeeData?.clientName}
                            onChange={(event) => requestFeeDataHandler(event.target.value, "clientName")}
                            onBlur={handleBlur}
                            error={Boolean(touched.clientName && errors.clientName)}
                        />
                        {touched.clientName && errors.clientName && (
                            <FormHelperText error>{errors.clientName}</FormHelperText>
                        )}
                    </FormControl>
                    <FormControl sx={{ width: "100%" }}>
                        <FormLabel error={Boolean(touched.feeType && errors.feeType)}>
                            Select Fee(s) {AstricUI}
                        </FormLabel>
                        <Select
                            displayEmpty
                            multiple
                            value={requestFeeData?.feeType || []}
                            onChange={(event) => requestFeeDataHandler(event.target.value, "feeType")}
                            onBlur={handleBlur}
                            name="feeType"
                            renderValue={(selected) => {
                                if (selected.length === 0) {
                                    return (
                                        <span
                                            style={{
                                                opacity: 0.5,
                                            }}>
                                            Select fee
                                        </span>
                                    );
                                }
                                return selected.join(", ");
                            }}
                            error={Boolean(touched.feeType && errors.feeType)}>
                            {options.map((option) => (
                                <MenuItem key={option} value={option}>
                                    <Checkbox
                                        checked={requestFeeData?.feeType?.includes(option)}
                                        sx={{
                                            padding: 0,
                                            marginRight: "0.5rem",
                                        }}
                                    />
                                    <ListItemText primary={option} />
                                </MenuItem>
                            ))}
                        </Select>
                        {touched.feeType && errors.feeType && <FormHelperText error>{errors.feeType}</FormHelperText>}
                    </FormControl>
                    {requestFeeData?.feeType?.includes("Custom") && (
                        <FormControl sx={{ width: "100%" }}>
                            <FormLabel error={Boolean(touched.additionalDetails && errors.additionalDetails)}>
                                Additional Details {AstricUI}
                            </FormLabel>
                            <OutlinedInput
                                placeholder="Enter additional details"
                                sx={{}}
                                name="additionalDetails"
                                value={requestFeeData?.additionalDetails}
                                onChange={(event) => requestFeeDataHandler(event.target.value, "additionalDetails")}
                                onBlur={handleBlur}
                                error={Boolean(touched.additionalDetails && errors.additionalDetails)}
                            />
                            {touched.additionalDetails && errors.additionalDetails && (
                                <FormHelperText error>{errors.additionalDetails}</FormHelperText>
                            )}
                        </FormControl>
                    )}
                    <FormControl sx={{ width: "100%" }}>
                        <FormControlLabel
                            control={<Checkbox checked={isEventDatesTBHChecked} onChange={handleEventDateTBH} />}
                            label={<>Event Dates TBD</>}
                            sx={{
                                marginBottom: "10px",
                                "& .MuiTypography-root.MuiFormControlLabel-label":{
                                    color:"#344054",
                                    fontSize:"14px",
                                    fontWeight:"500"
                                }
                            }}
                        />
                    </FormControl>
                    <Grid
                        sx={{}}
                        container
                        columnSpacing={1}
                        rowSpacing={{
                            xs: 2,
                            sm: 0,
                        }}>
                        <Grid xs={12} sm={6} item>
                            <FormControl
                                className="disabledGuttorTop"
                                sx={{ width: "100%" }}
                                disabled={isEventDatesTBHChecked}>
                                <FormLabel error={Boolean(touched.startEventDate && errors.startEventDate)}>
                                    Start Event Date {AstricUI}
                                </FormLabel>
                                <Box
                                    sx={{
                                        marginTop: "-1rem",
                                        "& .MuiFormControl-root": { width: "100%" },
                                    }}
                                    fullWidth>
                                    <LocalizationProvider dateAdapter={AdapterDayjs} fullWidth sx={{ mt: 0 }}>
                                        <DatePicker
                                            value={
                                                requestFeeData?.startEventDate ? requestFeeData?.startEventDate : null
                                            }
                                            onChange={(newValue) => requestFeeDataHandler(newValue, "startEventDate")}
                                            minDate={new Date()}
                                            disabled={isEventDatesTBHChecked}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    name="startEventDate"
                                                    sx={{
                                                        "& .MuiIconButton-root": {
                                                            marginRight: "0px",
                                                        },
                                                    }}
                                                    onBlur={handleBlur}
                                                    placeholder="Select event date"
                                                    error={Boolean(touched.startEventDate && errors.startEventDate)}
                                                    helperText={touched.startEventDate && errors.startEventDate}
                                                />
                                            )}
                                        />
                                    </LocalizationProvider>
                                </Box>
                            </FormControl>
                        </Grid>
                        <Grid xs={12} sm={6} item>
                            <FormControl
                                className="disabledGuttorTop"
                                sx={{ width: "100%" }}
                                disabled={isEventDatesTBHChecked}>
                                <FormLabel error={Boolean(touched.endEventDate && errors.endEventDate)}>
                                    End Event Date {AstricUI}
                                </FormLabel>
                                <Box
                                    sx={{
                                        marginTop: "-1rem",
                                        "& .MuiFormControl-root": { width: "100%" },
                                    }}
                                    fullWidth>
                                    <LocalizationProvider dateAdapter={AdapterDayjs} fullWidth sx={{ mt: 0 }}>
                                        <DatePicker
                                            value={
                                                requestFeeData?.endEventDate
                                                    ? requestFeeData?.endEventDate
                                                    : requestFeeData?.startEventDate
                                                    ? requestFeeData?.startEventDate
                                                    : null
                                            }
                                            onChange={(newValue) => requestFeeDataHandler(newValue, "endEventDate")}
                                            minDate={
                                                requestFeeData?.startEventDate
                                                    ? requestFeeData?.startEventDate
                                                    : new Date()
                                            }
                                            maxDate={
                                                requestFeeData?.startEventDate
                                                    ? new Date(requestFeeData?.startEventDate).setDate(
                                                          new Date(requestFeeData?.startEventDate).getDate() + 4
                                                      )
                                                    : new Date().setDate(new Date().getDate() + 4)
                                            }
                                            disabled={isEventDatesTBHChecked}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    name="endEventDate"
                                                    sx={{
                                                        "& .MuiIconButton-root": {
                                                            marginRight: "0px",
                                                        },
                                                    }}
                                                    onBlur={handleBlur}
                                                    placeholder="Select event date"
                                                    error={Boolean(touched.endEventDate && errors.endEventDate)}
                                                    helperText={touched.endEventDate && errors.endEventDate}
                                                />
                                            )}
                                        />
                                    </LocalizationProvider>
                                </Box>
                            </FormControl>
                        </Grid>
                    </Grid>

                    <FormControl fullWidth disabled={false}>
                        <FormLabel>Event Type {AstricUI}</FormLabel>
                        <Select
                            labelId="eventType-label"
                            id="eventType-select"
                            variant="outlined"
                            placeholder="Select Event Type"
                            name="eventType"
                            value={requestFeeData?.eventType ? requestFeeData?.eventType : "In person"}
                            displayEmpty={true}
                            onChange={(event) => requestFeeDataHandler(event.target.value, "eventType")}
                            onBlur={handleBlur}
                            error={Boolean(touched.eventType && errors.eventType)}>
                            <MenuItem value={"In person"}>In person</MenuItem>
                            <MenuItem value={"Virtual"}>Virtual</MenuItem>
                        </Select>
                        {touched.eventType && errors.eventType && (
                            <FormHelperText error>{errors.eventType}</FormHelperText>
                        )}
                    </FormControl>
                    {requestFeeData?.eventType === "In person" && (
                        <Box>
                            <FormControl sx={{ width: "100%" }}>
                                <FormControlLabel
                                    control={<Checkbox checked={isAddressTBHChecked} onChange={handleAddressCityTBH} />}
                                    label={'Event City TBD'}
                                    sx={{
                                        marginBottom: "10px",

                                        "& .MuiTypography-root.MuiFormControlLabel-label":{
                                            color:"#344054",
                                            fontSize:"14px",
                                            fontWeight:"500"
                                        }
                                    }}
                                />
                            </FormControl>
                            <Grid
                                sx={{}}
                                container
                                columnSpacing={1}
                                rowSpacing={{
                                    xs: 2,
                                    sm: 0,
                                }}>
                                <Grid xs={12} sm={6} item>
                                    <FormControl
                                        className="disabledGuttorTop"
                                        sx={{ width: "100%" }}
                                        disabled={isAddressTBHChecked}>
                                        <FormLabel error={Boolean(touched.eventCity && errors.eventCity)}>
                                            Event City {AstricUI}
                                        </FormLabel>
                                        <OutlinedInput
                                            placeholder="Enter city"
                                            sx={{}}
                                            name="eventCity"
                                            value={requestFeeData?.eventCity}
                                            onChange={(event) => requestFeeDataHandler(event.target.value, "eventCity")}
                                            onBlur={handleBlur}
                                            error={Boolean(touched.eventCity && errors.eventCity)}
                                        />

                                        {touched.eventCity && errors.eventCity && (
                                            <FormHelperText error>{errors.eventCity}</FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>
                                <Grid xs={12} sm={6} item>
                                    <FormControl className="disabledGuttorTop" sx={{ width: "100%" }} disabled={false}>
                                        <FormLabel error={Boolean(touched.eventState && errors.eventState)}>
                                            Event State {AstricUI}
                                        </FormLabel>
                                        <OutlinedInput
                                            placeholder="Enter state"
                                            sx={{}}
                                            name="eventState"
                                            value={requestFeeData?.eventState}
                                            onChange={(event) =>
                                                requestFeeDataHandler(event.target.value, "eventState")
                                            }
                                            onBlur={handleBlur}
                                            error={Boolean(touched.eventState && errors.eventState)}
                                        />

                                        {touched.eventState && errors.eventState && (
                                            <FormHelperText error>{errors.eventState}</FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Box>
                    )}

                    <FormControl fullWidth disabled={false}>
                        <FormLabel error={Boolean(touched.eventCountry && errors.eventCountry)}>
                            Event Country {AstricUI}
                        </FormLabel>
                        <Select
                            labelId="country-label"
                            id="country-select"
                            variant="outlined"
                            placeholder="Select country"
                            name="eventCountry"
                            sx={{
                                color: requestFeeData?.eventCountry ? "inherit" : "#a7a7a8",
                            }}
                            value={requestFeeData?.eventCountry ? requestFeeData?.eventCountry : ""}
                            displayEmpty={true}
                            onChange={(event) => requestFeeDataHandler(event.target.value, "eventCountry")}
                            onBlur={handleBlur}
                            error={Boolean(touched.eventCountry && errors.eventCountry)}>
                            <MenuItem value={""} sx={{ color: "gray" }}>
                                {"Select country"}
                            </MenuItem>
                            {countryPicklist?.map((item) => (
                                <MenuItem value={item.value}>{item.label}</MenuItem>
                            ))}
                        </Select>

                        {touched.eventCountry && errors.eventCountry && (
                            <FormHelperText error>{errors.eventCountry}</FormHelperText>
                        )}
                    </FormControl>

                    <FormControl sx={{ width: "100%" }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={requestFeeData.requestedAvailability}
                                    onChange={(event) =>
                                        requestFeeDataHandler(event.target.checked, "requestedAvailability")
                                    }
                                />
                            }
                            label={
                                <>
                                    Request Availability{" "}
                                    <span style={{ fontSize: "10px" }}>
                                        (We’ll use your fee request information to check the speaker’s availability)
                                    </span>
                                </>
                            }
                            sx={{
                                marginBottom: "10px",
                                "& .MuiTypography-root.MuiFormControlLabel-label":{
                                    color:"#344054",
                                    fontSize:"14px",
                                    fontWeight:"500"
                                }
                            }}
                        />
                    </FormControl>

                    <FormControl sx={{ width: "100%" }}>
                        <FormLabel error={Boolean(touched.requestNotes && errors.requestNotes)}>
                            Request Details {AstricUI}
                        </FormLabel>
                        <OutlinedInput
                            placeholder="Enter request details"
                            name="requestNotes"
                            value={requestFeeData?.requestNotes}
                            onChange={(event) => requestFeeDataHandler(event.target.value, "requestNotes")}
                            onBlur={handleBlur}
                            multiline
                            rows={3}
                            error={Boolean(touched.requestNotes && errors.requestNotes)}
                        />
                        {touched.requestNotes && errors.requestNotes && (
                            <FormHelperText error>{errors.requestNotes}</FormHelperText>
                        )}
                    </FormControl>

                    <Box
                        padding={"10px 16px"}
                        marginTop={"1rem"}
                        border={"1px solid #E6E8F0"}
                        borderRadius={"10px"}
                        display={"flex"}>
                        <InfoOutlined
                            fontSize="small"
                            sx={{
                                marginTop: "4px",
                                marginRight: "8px",
                            }}
                        />{" "}
                        <Typography component={"p"} fontSize={"14px"}>
                            You are requesting a standard fee for its typical engagement. For events longer than two
                            hours, please share additional details above.
                        </Typography>
                    </Box>
                </Box>
            </Modal>
        </>
    );
}

export default RequestFeeFormModal;
